import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NotificationSystem from 'react-notification-system';
import { restartInterval } from '../../../utils/AthuService';
import { myLog } from '../../../utils/Utility';

let style = {
    NotificationItem: {
        DefaultStyle: {
            margin: '10px 5px 2px 1px',
        },
    },
};

class Notification extends Component {
    static propTypes = {
        notification: PropTypes.object,
    };

    //componentDidMount
    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
    }

    //showNotify
    showNotify(obj) {
        restartInterval();
        if (obj.status) {
            this._notificationSystem.addNotification({
                message: obj.message,
                level: obj.type,
            });
        }
    }

    /**
     * Render Page
     */
    render() {
        if (typeof this.props.notification.notificationDetails !== 'undefined') {
            myLog('notificationReducer', this.props.notification.notificationDetails);
            this.showNotify(this.props.notification.notificationDetails);
        }

        return (
            <div>
                <NotificationSystem ref="notificationSystem" style={style} className="demo" />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        notification: state.NotificationReducer,
    };
};

export default connect(mapStateToProps, {})(Notification);
